/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DirectoryReviewSettings = {
  /**
   * Whether organization admins are emailed when directory changes are waiting for a decision. On by default.
   */
  emailsEnabled: boolean;
};

/** @internal */
export const DirectoryReviewSettings$inboundSchema: z.ZodMiniType<
  DirectoryReviewSettings,
  unknown
> = z.pipe(
  z.object({
    emails_enabled: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "emails_enabled": "emailsEnabled",
    });
  }),
);
/** @internal */
export type DirectoryReviewSettings$Outbound = {
  emails_enabled: boolean;
};

/** @internal */
export const DirectoryReviewSettings$outboundSchema: z.ZodMiniType<
  DirectoryReviewSettings$Outbound,
  DirectoryReviewSettings
> = z.pipe(
  z.object({
    emailsEnabled: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      emailsEnabled: "emails_enabled",
    });
  }),
);

export function directoryReviewSettingsToJSON(
  directoryReviewSettings: DirectoryReviewSettings,
): string {
  return JSON.stringify(
    DirectoryReviewSettings$outboundSchema.parse(directoryReviewSettings),
  );
}
export function directoryReviewSettingsFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryReviewSettings, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryReviewSettings$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryReviewSettings' from JSON`,
  );
}
